// packages/frontend/src/pages/admin/RegionsTab.tsx
import { NamedRegionsList } from '../../components/admin/NamedRegionsList';

export function RegionsTab() {
  return <NamedRegionsList />;
}
